import styled from "@emotion/styled";

const CommonComponents = styled.div``;

CommonComponents.Wrapper = styled.div`
  display: inherit;
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  max-height: inherit;
  min-height: inherit;
  ${({ height }) => height && `height: ${height};`}
`;
export default CommonComponents;
